import script from "./journey.vue?vue&type=script&setup=true&lang=ts"
export * from "./journey.vue?vue&type=script&setup=true&lang=ts"

import "./journey.vue?vue&type=style&index=0&id=434999dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-434999dc"]])

export default __exports__